import { BATH_STATES } from '../../../constants/shared/bath/states';

export const reducers = {
  requestState(state, { payload: nextState }) {
    if (state.state !== nextState) {
      state.previousStates.push(state.state);
      state.state = nextState;
      handleBath(state);
    }
  },
  requestPreviousState(state) {
    if (state.previousStates.length) {
      state.state = state.previousStates.pop();
      handleBath(state);
    }
  },
};

function handleBath(state) {
  const { isBath, state: appState } = state;
  if (isBath && !BATH_STATES.includes(appState)) state.isBath = false;
}
